<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <div v-if="chatIsEdit && selectedChatForEdit">
          <div class="mb-3">
            <b>{{ selectedChatForEdit.userFullName }}</b>
            <span class="mr-2">{{
              selectedChatForEdit.createdTimeUtc | moment
            }}</span>
            <small v-if="selectedChatForEdit.edited">(ویرایش شده)</small>
          </div>
        </div>
        <v-form ref="chatForm" v-model="chatValid">
          <v-row>
            <v-col cols="12">
              <v-textarea
                rows="1"
                auto-grow
                max-height="100px"
                autofocus
                label="متن پیام"
                outlined
                dense
                :required="chat.body && chat.body.length"
                :rules="[
                  (v) => {
                    if (v && (v.length > 4096 || v.length < 1)) {
                      return 'تعداد کاراکتر ها باید بین 1 تا 4096 عدد باشد';
                    } else return true;
                  },
                ]"
                v-model="chat.body"
              ></v-textarea>
            </v-col>

            <v-row class="mx-5">
              <!-- <v-col cols="2"> -->
              <v-btn icon small @click="sendMessage()">
                <v-icon> mdi-send </v-icon>
              </v-btn>
              <v-btn icon small @click="closeForm()">
                <v-icon> mdi-close </v-icon>
              </v-btn>

              <FileUpload
                class="mb-4 mt-n2"
                :files="attachments"
                ref="filesUploder"
              ></FileUpload>
              <!-- <audio-recorder
                upload-url="YOUR_API_URL"
                :attempts="3"
                :time="10"
                :headers="headers"
                :before-recording="callback"
                :pause-recording="callback"
                :after-recording="callback"
                :select-record="callback"
                :before-upload="callback"
                :successful-upload="callback"
                :failed-upload="callback"
              /> -->
            </v-row>
          </v-row>
        </v-form>
        <div
          class="mt-3"
          v-if="selectedChatForEdit && selectedChatForEdit.isRead && chatIsEdit"
        >
          <span>خوانده شده</span>
          <span class="mr-2">{{
            selectedChatForEdit.readTimeUtc | moment
          }}</span>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
//import AudioRecorder from 'vue2-audio-recorder';
import FileUpload from './FileUpload.vue';
import Helper from '@/core/helpers';
import { uuid } from 'vue-uuid';
const conversationRepository = () => RepoFactory.get('conversation');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  props: {
    chatIsEdit: {
      type: Boolean,
      default: false,
    },
    selectedChatForEdit: {
      type: Object,
      default: null,
    },
    conversationId: {
      type: String,
      default: null,
    },
    type: {
      type: String,
    },
    topic: {
      type: String,
    },
    objectId: {
      type: String,
    },
    recipientMerchantId: {
      type: String,
    },
    recipientUserId: {
      type: String,
    },
    createdByMerchantId: {
      type: String,
    },
    isUserBase: {
      type: Boolean,
      default: null,
    },
  },
  components: {
    FileUpload,
    //AudioRecorder,
  },
  data() {
    return {
      chatValid: true,
      chat: {
        body: null,
        attachments: [],
      },
      attachments: [],
      headers:{},
    };
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
  },
  created() {
    if (this.chatIsEdit && this.selectedChatForEdit) {
      this.fillInput();
    }
  },
  watch: {
    chatIsEdit(after, before) {
      if (after && this.selectedChatForEdit) {
        this.fillInput();
      }
    },
  },
  methods: {
    fillInput() {
      this.chat = {
        body: this.selectedChatForEdit.body,
        attachments: [],
      };
      this.attachments = this.selectedChatForEdit.attachments;
      if (
        this.selectedChatForEdit.attachments &&
        this.selectedChatForEdit.attachments.length
      ) {
        this.selectedChatForEdit.attachments.forEach((element) => {
          this.chat.attachments.push(element.fileId);
        });
      }
    },
    closeForm() {
      // this.chat.body = '';
      this.$refs.chatForm.reset();
      this.chat.attachments = [];
      this.attachments = [];
      this.$refs.filesUploder.uploadedFilesId = [];
      this.$emit('closeChatForm');
    },
    sendMessage() {
      if (
        this.$refs.chatForm.validate() &&
        this.chat.body &&
        this.chat.body.length
      ) {
        if (
          this.$refs.filesUploder.uploadedFilesId &&
          this.$refs.filesUploder.uploadedFilesId.length
        ) {
          this.chat.attachments = [this.$refs.filesUploder.uploadedFilesId[0]];
        }
        if (!this.chatIsEdit) {
          this.createMessage();
        } else {
          this.editMessage();
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن متن پیام الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    createMessage() {
      const loader = this.$loading.show();
      this.chat.conversationId = this.conversationId;
      this.chat.objectId = this.objectId;
      this.chat.createdByMerchantId = this.createdByMerchantId;
      this.chat.recipientUserId = this.recipientUserId;
      this.chat.recipientMerchantId = this.recipientMerchantId;
      this.chat.type = this.type;
      this.chat.topic = this.topic;
      this.chat.parentId = null;

      this.chat.isUserBased = this.isUserBase;

      conversationRepository()
        .addConversation(this.chat, this.baseUrl, {
          MerchantId: this.$store.getters.currentMerchant,
        })
        .then((res) => {
          this.$dialog.message.success('با موفقیت ثبت گردید', {
            position: 'top-left',
          });
          if (!this.conversationId) {
            conversationRepository()
              .getConversation(
                this.baseUrl,
                {},
                {
                  type: this.type,
                  topic: this.topic,
                  objectId: this.objectId,
                  PageNumber: 1,
                  ItemsPerPage: 10,
                }
              )
              .then((res) => {
                console.log(res.data);
                let newThread = {
                  attachments: res.data.list[0].attachments,
                  id: res.data.list[0].id,
                  conversationId: res.data.list[0].conversationId,
                  body: res.data.list[0].body,
                  status: 'Sent',
                  parentId: null,
                  parentBody: null,
                  isMainThread: true,
                  isMine: true,
                };
                this.$emit(
                  'getConversationId',
                  res.data.list[0].conversationId
                );

                this.$emit('addNewThread', newThread);
                this.closeForm();
              })
              .catch();
          } else {
            conversationRepository()
              .getConversationById(
                this.chat.conversationId,
                this.baseUrl,
                {},
                { threadId: res.data.id }
              )
              .then((res) => {
                let newThread = {
                  attachments: res.data.attachments,
                  id: res.data.id,
                  conversationId: this.chat.conversationId,
                  body: this.chat.body,
                  status: 'Sent',
                  parentId: null,
                  parentBody: null,
                  isMainThread: true,
                  isMine: true,
                };
                this.$emit('addNewThread', newThread);
                this.closeForm();
              })
              .catch();
          }
          // this.$emit('getConversaion');
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    editMessage() {
      this.chat.threadId = this.selectedChatForEdit.id;
      const loader = this.$loading.show();
      conversationRepository()
        .editConversation(
          this.selectedChatForEdit.conversationId,
          this.chat,
          this.baseUrl,
          { MerchantId: this.$store.getters.currentMerchant }
        )
        .then((data) => {
          this.$dialog.message.success('با موفقیت ثبت گردید', {
            position: 'top-left',
          });
          this.closeForm();
          this.$emit('getConversaion');

          // this.attachments= []
          // this.chat.attachments = []
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    callback(data) {
      console.debug(data);
    },
  },
};
</script>

<style></style>
